import { ItemType, OrderLineCollectionStatus, OrderLineRefundStatus } from '@vista-digital/ocapi-types/v1';
import { getZeroMonetaryValue } from '../../../../../utils/monetary-value-utils';
import { createUUID } from '../../../../../utils/uuid-utils';
export const mapInProgressNormalItemToOrderNormalItemLine = (inProgressItem) => {
    return {
        itemId: inProgressItem.item.id,
        type: ItemType.Normal,
        price: inProgressItem.totalPrice,
        amountSaved: inProgressItem.totalSavings,
        modifierGroups: inProgressItem.modifierGroups.map(mapInProgressItemModifierGroupToOrderItemModifierGroup),
        discountId: inProgressItem.discountId,
        rewardId: inProgressItem.rewardId,
        id: createUUID(),
        collectionStatus: OrderLineCollectionStatus.NotCollected,
        refundStatus: OrderLineRefundStatus.NotRefunded
    };
};
const mapInProgressItemModifierGroupToOrderItemModifierGroup = (inProgressItemModifierGroup) => {
    return {
        itemModifierGroupId: inProgressItemModifierGroup.itemModifierGroupId,
        modifiers: inProgressItemModifierGroup.modifiers.reduce((modifiers, inProgressItemModifier) => {
            modifiers.push(...mapInProgressItemModifierToOrderItemModifier(inProgressItemModifier));
            return modifiers;
        }, [])
    };
};
const mapInProgressItemModifierToOrderItemModifier = (inProgressItemModifier) => {
    // Expand quantity into individual order item modifiers
    return [...Array(inProgressItemModifier.quantity)].reduce((modifiers, _, i) => {
        const isFree = i < inProgressItemModifier.freeQuantity;
        modifiers.push({
            itemId: inProgressItemModifier.itemId,
            price: isFree ? getZeroMonetaryValue() : inProgressItemModifier.selectedPrice.price,
            amountSaved: inProgressItemModifier.totalSavings
        });
        return modifiers;
    }, []);
};
